import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

// ─── Website Data ────────────────────────────────────────────────────────────
const websites = [
  {
    id: 1,
    title: "Flappy Bird Game",
    description:
      "A fun and addictive Flappy Bird clone built from scratch with vanilla HTML, CSS, and JavaScript. Features smooth animations and score tracking.",
    image: "/images/flappy-bird.png",
    url: "https://flapy-bird-box.netlify.app/",
    tags: ["HTML", "CSS", "JavaScript"],
  },
  {
    id: 2,
    title: "Code Maestro",
    description:
      "A platform to share and showcase code snippets with Firebase-powered backend, authentication, and a Material-UI design system.",
    image: "/images/code-miestro.png",
    url: "https://code-miestro.netlify.app/",
    tags: ["HTML", "Firebase", "Material-UI", "JavaScript"],
  },
  {
    id: 3,
    title: "Spotify Clone",
    description:
      "A sleek Spotify-inspired music streaming interface with API integration, responsive design, and smooth playback controls.",
    image: "/images/spotify.png",
    url: "https://apmamusic.netlify.app/",
    tags: ["JavaScript", "API", "CSS3", "Responsive"],
  },
  {
    id: 4,
    title: "Color Predict Game",
    description:
      "An interactive color prediction game with Firebase leaderboard integration. Test your color perception skills!",
    image: "/images/color predict.png",
    url: "https://color-predict.netlify.app/",
    tags: ["HTML", "CSS", "JavaScript", "Firebase"],
  },
  {
    id: 5,
    title: "Cloud Files Storage",
    description:
      "A file storage and sharing platform with React.js backend, user authentication, and a clean Material-UI design system.",
    image: "/images/cloud file storage.png",
    url: "https://cloud-files-storage.netlify.app/",
    tags: ["React.js", "CSS", "JavaScript"],
  },
  {
    id: 6,
    title: "Word to PDF Converter",
    description:
      "A word to PDF converter application built with React.js and Material-UI. Features timer, scoring, and responsive design.",
    image: "/images/word to pdf.png",
    url: "https://word-to-pdf-29hdi9e.netlify.app/",
    tags: ["HTML", "CSS", "JavaScript"],
  },
  {
    id: 7,
    title: "Convert All In One",
    description:
      "A convert all in one application built with vanilla HTML, CSS, and JavaScript. Features smooth animations and responsive design.",
    image: "/images/convert all in one.png",
    url: "https://convert-all-in-one.netlify.app/",
    tags: ["HTML", "CSS", "JavaScript"],
  },
  {
    id: 8,
    title: "Code Companions",
    description:
      "A code companions application built with vanilla HTML, CSS, and JavaScript. Features smooth animations and responsive design.",
    image: "/images/code-companions.png",
    url: "https://code-companions.netlify.app/",
    tags: ["HTML", "CSS", "JavaScript"],
  },
  {
    id: 9,
    title: "PNG Ninja",
    description:
      "A png ninja application built with vanilla HTML, CSS, and JavaScript. Features smooth animations and responsive design.",
    image: "/images/png-ninja.png",
    url: "https://png-ninja.netlify.app/",
    tags: ["HTML", "CSS", "JavaScript"],
  },
    {
    id: 10,
    title: "QR-CODE GENERATOR",
    description:
      "A QR code generator application built with vanilla HTML, CSS, and JavaScript. Features smooth animations and responsive design.",
    image: "/images/qr code generator.png",
    url: "https://qr-codes-gen.netlify.app/",
    tags: ["HTML", "CSS", "JavaScript"],
  },
  {
    id: 11,
    title: "Music App",
    description:
      "A music app built with vanilla HTML, CSS, and JavaScript. Features smooth animations and responsive design.",
    image: "/images/music-0-app.png",
    url: "https://music-0-app.netlify.app/",
    tags: ["HTML", "CSS", "JavaScript"],
  },
  {
    id: 12,
    title: "Color Prediction Game",
    description:
      "A color prediction game built with vanilla HTML, CSS, and JavaScript. Features smooth animations and responsive design.",
    image: "/images/color-predict.png",
    url: "https://color-predict.netlify.app/",
    tags: ["HTML", "CSS", "JavaScript"],
  },
  
 
];

// ─── Styles ──────────────────────────────────────────────────────────────────

const COLORS = {
  bg: "#0D1117",
  card: "#161B22",
  text: "#C9D1D9",
  muted: "#8B949E",
  accent: "#58A6FF",
  accentAlt: "#7C3AED",
  green: "#238636",
  border: "#30363D",
  borderHover: "#58A6FF",
};

const styles = {
  page: {
    minHeight: "100vh",
    background: `linear-gradient(135deg, ${COLORS.bg} 0%, #0a0f18 40%, ${COLORS.card} 100%)`,
    color: COLORS.text,
    fontFamily:
      '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    padding: "100px 20px 60px",
    position: "relative",
    overflow: "hidden",
  },

  // Ambient glow orbs
  orb1: {
    position: "fixed",
    top: "-20%",
    right: "-10%",
    width: "600px",
    height: "600px",
    borderRadius: "50%",
    background:
      "radial-gradient(circle, rgba(88,166,255,0.08) 0%, transparent 70%)",
    pointerEvents: "none",
    zIndex: 0,
  },
  orb2: {
    position: "fixed",
    bottom: "-15%",
    left: "-10%",
    width: "500px",
    height: "500px",
    borderRadius: "50%",
    background:
      "radial-gradient(circle, rgba(124,58,237,0.06) 0%, transparent 70%)",
    pointerEvents: "none",
    zIndex: 0,
  },

  // Back button
  backBtn: {
    position: "fixed",
    top: 20,
    left: 20,
    zIndex: 1100,
    background: "rgba(255,255,255,0.06)",
    backdropFilter: "blur(16px)",
    WebkitBackdropFilter: "blur(16px)",
    border: `1px solid ${COLORS.border}`,
    borderRadius: 50,
    padding: "10px 24px",
    color: COLORS.accent,
    cursor: "pointer",
    fontSize: 14,
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
    gap: 8,
    transition: "all .3s cubic-bezier(.4,0,.2,1)",
    textDecoration: "none",
  },

  // Header
  headerContainer: {
    textAlign: "center",
    marginBottom: 56,
    position: "relative",
    zIndex: 1,
  },
  badge: {
    display: "inline-block",
    padding: "6px 18px",
    borderRadius: 50,
    background: "rgba(88,166,255,0.1)",
    border: `1px solid rgba(88,166,255,0.25)`,
    color: COLORS.accent,
    fontSize: 13,
    fontWeight: 600,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    marginBottom: 20,
  },
  heading: {
    fontSize: "clamp(32px, 5vw, 48px)",
    fontWeight: 800,
    background: `linear-gradient(135deg, ${COLORS.accent}, ${COLORS.accentAlt}, #f472b6)`,
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
    marginBottom: 12,
    lineHeight: 1.2,
  },
  subheading: {
    fontSize: 16,
    color: COLORS.muted,
    maxWidth: 540,
    margin: "0 auto",
    lineHeight: 1.6,
  },

  // Grid
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(340px, 1fr))",
    gap: 28,
    maxWidth: 1200,
    margin: "0 auto",
    position: "relative",
    zIndex: 1,
  },

  // Card
  card: {
    background: "rgba(22,27,34,0.6)",
    backdropFilter: "blur(20px)",
    WebkitBackdropFilter: "blur(20px)",
    borderRadius: 20,
    border: `1px solid ${COLORS.border}`,
    overflow: "hidden",
    cursor: "pointer",
    transition: "all .4s cubic-bezier(.4,0,.2,1)",
    position: "relative",
    textDecoration: "none",
    color: "inherit",
    display: "block",
  },
  cardHover: {
    transform: "translateY(-8px)",
    boxShadow: "0 20px 60px rgba(88,166,255,0.12), 0 4px 20px rgba(0,0,0,0.4)",
    borderColor: "rgba(88,166,255,0.4)",
  },

  // Image container
  imageContainer: {
    position: "relative",
    width: "100%",
    paddingTop: "56.25%", // 16:9 aspect ratio
    overflow: "hidden",
    background: "rgba(0,0,0,0.3)",
  },
  image: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    transition: "transform .5s cubic-bezier(.4,0,.2,1)",
  },
  imageHover: {
    transform: "scale(1.06)",
  },
  imageOverlay: {
    position: "absolute",
    inset: 0,
    background:
      "linear-gradient(180deg, transparent 40%, rgba(13,17,23,0.9) 100%)",
    opacity: 0,
    transition: "opacity .4s ease",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  imageOverlayVisible: {
    opacity: 1,
  },
  visitBtn: {
    padding: "12px 28px",
    borderRadius: 50,
    background: `linear-gradient(135deg, ${COLORS.accent}, ${COLORS.accentAlt})`,
    color: "#fff",
    fontWeight: 700,
    fontSize: 14,
    border: "none",
    display: "flex",
    alignItems: "center",
    gap: 8,
    letterSpacing: "0.02em",
    boxShadow: "0 4px 20px rgba(88,166,255,0.3)",
    transform: "translateY(20px)",
    opacity: 0,
    transition: "all .3s cubic-bezier(.4,0,.2,1) .1s",
    pointerEvents: "none",
  },
  visitBtnVisible: {
    transform: "translateY(0)",
    opacity: 1,
  },

  // Card content
  cardContent: {
    padding: "20px 24px 24px",
  },
  cardTitle: {
    fontSize: 20,
    fontWeight: 700,
    color: "#E6EDF3",
    marginBottom: 8,
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  cardDescription: {
    fontSize: 14,
    color: COLORS.muted,
    lineHeight: 1.6,
    marginBottom: 16,
  },
  tags: {
    display: "flex",
    flexWrap: "wrap",
    gap: 8,
  },
  tag: {
    padding: "4px 12px",
    borderRadius: 50,
    background: "rgba(88,166,255,0.08)",
    border: "1px solid rgba(88,166,255,0.15)",
    color: COLORS.accent,
    fontSize: 12,
    fontWeight: 500,
  },

  // External link icon on card
  externalIcon: {
    position: "absolute",
    top: 16,
    right: 16,
    width: 36,
    height: 36,
    borderRadius: 10,
    background: "rgba(0,0,0,0.5)",
    backdropFilter: "blur(8px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: COLORS.accent,
    opacity: 0,
    transition: "opacity .3s ease",
    zIndex: 2,
  },
  externalIconVisible: {
    opacity: 1,
  },

  // Stats section
  statsBar: {
    display: "flex",
    justifyContent: "center",
    gap: 48,
    marginBottom: 48,
    position: "relative",
    zIndex: 1,
  },
  stat: {
    textAlign: "center",
  },
  statNumber: {
    fontSize: 32,
    fontWeight: 800,
    background: `linear-gradient(135deg, ${COLORS.accent}, ${COLORS.accentAlt})`,
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
  },
  statLabel: {
    fontSize: 13,
    color: COLORS.muted,
    marginTop: 4,
    textTransform: "uppercase",
    letterSpacing: "0.08em",
    fontWeight: 500,
  },
};

// ─── Inject Keyframes ────────────────────────────────────────────────────────
const KEYFRAMES_ID = "services-keyframes";
if (typeof document !== "undefined" && !document.getElementById(KEYFRAMES_ID)) {
  const sheet = document.createElement("style");
  sheet.id = KEYFRAMES_ID;
  sheet.textContent = `
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
    
    @keyframes fadeInUp {
      from { transform: translateY(30px); opacity: 0; }
      to   { transform: translateY(0);    opacity: 1; }
    }
    @keyframes fadeIn {
      from { opacity: 0; }
      to   { opacity: 1; }
    }
    @keyframes pulseGlow {
      0%, 100% { box-shadow: 0 0 20px rgba(88,166,255,0.1); }
      50%      { box-shadow: 0 0 40px rgba(88,166,255,0.2); }
    }
  `;
  document.head.appendChild(sheet);
}

// ─── WebsiteCard Component ───────────────────────────────────────────────────

function WebsiteCard({ site, index }) {
  const [hovered, setHovered] = useState(false);

  return (
    <a
      href={site.url}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        ...styles.card,
        ...(hovered ? styles.cardHover : {}),
        animation: `fadeInUp 0.6s cubic-bezier(.4,0,.2,1) ${index * 0.12}s both`,
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      id={`service-card-${site.id}`}
    >
      {/* External link indicator */}
      <div
        style={{
          ...styles.externalIcon,
          ...(hovered ? styles.externalIconVisible : {}),
        }}
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6" />
          <polyline points="15 3 21 3 21 9" />
          <line x1="10" y1="14" x2="21" y2="3" />
        </svg>
      </div>

      {/* Image */}
      <div style={styles.imageContainer}>
        <img
          src={site.image}
          alt={site.title}
          style={{
            ...styles.image,
            ...(hovered ? styles.imageHover : {}),
          }}
          loading="lazy"
        />
        <div
          style={{
            ...styles.imageOverlay,
            ...(hovered ? styles.imageOverlayVisible : {}),
          }}
        >
          <div
            style={{
              ...styles.visitBtn,
              ...(hovered ? styles.visitBtnVisible : {}),
            }}
          >
            <span>Visit Website</span>
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M7 17L17 7M17 7H7M17 7V17" />
            </svg>
          </div>
        </div>
      </div>

      {/* Content */}
      <div style={styles.cardContent}>
        <h3 style={styles.cardTitle}>
          {site.title}
        </h3>
        <p style={styles.cardDescription}>{site.description}</p>
        <div style={styles.tags}>
          {site.tags.map((tag, i) => (
            <span key={i} style={styles.tag}>
              {tag}
            </span>
          ))}
        </div>
      </div>
    </a>
  );
}

// ─── Main Services Component ─────────────────────────────────────────────────

export default function Services() {
  const navigate = useNavigate();
  const [backHovered, setBackHovered] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <div style={styles.page}>
      {/* Ambient background orbs */}
      <div style={styles.orb1} />
      <div style={styles.orb2} />

      {/* Back button */}
      <button
        style={{
          ...styles.backBtn,
          ...(backHovered
            ? {
                background: "rgba(88,166,255,0.12)",
                borderColor: "rgba(88,166,255,0.4)",
                transform: "translateX(-2px)",
              }
            : {}),
        }}
        onClick={() => navigate("/")}
        onMouseEnter={() => setBackHovered(true)}
        onMouseLeave={() => setBackHovered(false)}
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M19 12H5M5 12L12 19M5 12L12 5" />
        </svg>
        Portfolio
      </button>

      {/* Header */}
      <div
        style={{
          ...styles.headerContainer,
          animation: mounted ? "fadeIn 0.8s ease" : "none",
        }}
      >
        <div style={styles.badge}>🌐 My Services</div>
        <h1 style={styles.heading}>Websites I've Built</h1>
        <p style={styles.subheading}>
          A showcase of live web projects — each crafted with clean code,
          modern design, and real-world functionality. Click any card to
          explore the live site.
        </p>
      </div>

      {/* Stats bar */}
      <div
        style={{
          ...styles.statsBar,
          animation: mounted ? "fadeInUp 0.6s ease 0.2s both" : "none",
        }}
      >
        <div style={styles.stat}>
          <div style={styles.statNumber}>{websites.length}</div>
          <div style={styles.statLabel}>Live Projects</div>
        </div>
        <div style={styles.stat}>
          <div style={styles.statNumber}>
            {[...new Set(websites.flatMap((w) => w.tags))].length}
          </div>
          <div style={styles.statLabel}>Technologies</div>
        </div>
        <div style={styles.stat}>
          <div style={styles.statNumber}>100%</div>
          <div style={styles.statLabel}>Hosted & Live</div>
        </div>
      </div>

      {/* Website Cards Grid */}
      <div style={styles.grid}>
        {websites.map((site, index) => (
          <WebsiteCard key={site.id} site={site} index={index} />
        ))}
      </div>
    </div>
  );
}
